export default function() {
	const { order, injured } = this
	let arr = [],
		injuredArr = injured.injuredList
	if (!(injuredArr && injuredArr.length > 0)) {
		injuredArr = [{ injuredName: '' }]
	}

	// 住院调解无车主，伤者影像信息
	if (this.isPureMediate) {
		const carOwnerIdentity = {
			title: '车主身份信息',
			children: [
				{ type: '5001', picName: '车主身份证正面' },
				{ type: '5002', picName: '车主身份证反面' },
				{ type: '5003', picName: '车主驾驶证正本正面' },
				{ type: '5004', picName: '车主驾驶证副本正面' },
				{ type: '5005', picName: '车主驾驶证副本反面' },
				{ type: '5006', picName: '车主行驶证正本正面' },
				{ type: '5007', picName: '车主行驶证副本正面' },
				{ type: '5008', picName: '车主行驶证副本反面' },
			],
			separateMedia: 'owner',
		}
		arr.push(carOwnerIdentity)

		injuredArr.forEach((item, index) => {
			const injuredInfo = {
				title: `伤者信息 - ${item.injuredName}`,
				desc:
					'要求：诊断证明、门诊病历本、检查报告、影像片、就诊发票五种类型有什么上传什么，没有可以不上传，拍摄清晰完整、近距离拍照',
				children: [
					{ type: '0003', picName: '伤者身份证正面' },
					{ type: '0004', picName: '伤者身份证反面' },
					{ type: '0002', picName: '伤者身份对比照' },
					{ type: '5009', picName: '伤者伤情照' },
					{ type: '0201', picName: '诊断证明' },
					{ type: '0202', picName: '门诊病历本' },
					{ type: '0203', picName: '检查报告' },
					{ type: '0501', picName: '影像片-片子全貌' },
					{ type: '050101', picName: '影像片-片头' },
					{ type: '050102', picName: '影像片-受伤细节' },
					{ type: '5010', picName: '就诊发票' },
				],
				separateMedia: `injuredList${index}`,
			}
			arr.push(injuredInfo)
		})
	}

	arr.push({
		title: '电子签名',
		slot: 'sign',
	})

	const signIn = {
		title: '签到',
		children: [{ type: '0406', picName: '作业人员和车主合照' }],
	}
	arr.push(signIn)

	if (this.isPureMediate) {
		arr.push({
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0900', picName: '其他' }],
		})
		if (this.isLastHalfMediate) {
			arr[arr.length - 1].children.push({ type: '0901', picName: '其他' })
		}
	} else {
		arr.push({
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0901', picName: '其他' }],
		})
	}
	arr.push({
		title: '视频信息',
		desc: '（非必传）',
		slot: 'videoList',
	})

	return arr
}
